import { createContext } from 'react'
const FormikContext = createContext(null as any)
export default FormikContext
